import EyeIcon from "../../IconsCode/EyeIcon";
import PrintIcon from "../../IconsCode/PrintIcon";
import EditIcon from "../../IconsCode/EditIcon";
import DeleteIcon from "../../IconsCode/DeleteIcon";

function UserActions({ onOpen }) {
  return (
    <div className="w-52 flex flex-row-reverse items-center justify-between">
      <EyeIcon onClick={() => onOpen("details")} />
      <PrintIcon onClick={() => onOpen("print")} />
      <EditIcon onClick={() => onOpen("edit")} />
      <DeleteIcon color="#B8AEC0" size="24" onClick={() => onOpen("delete")} />
    </div>
  );
}

export default UserActions;
